module.exports = __webpack_public_path__ + "img/highroller_460.98326c85.png";